// extracted by mini-css-extract-plugin
export default {"sidebar":"G346fe0","sidebar-open":"Gddf626","overlay":"G74fc51","overlay-on":"G4e160c","prevent-scroll":"G9c6d13"};